import {
  CONVERSATION_FACTS_DIMENSIONS,
  CONVERSATION_FACTS_ZONE_DIMENSIONS,
  DRIFT_APP_USER_FIRST_IN_CONVERSATION,
  DRIFT_CHAT_CLASSIFICATIONS_DIMENSIONS,
  DRIFT_CHAT_CONVERSATION_ROUTING_DIMENSIONS,
  DRIFT_CHAT_END_USERS_DIMENSIONS,
  DRIFT_CHAT_PLAYBOOK_DIMENSIONS,
  DRIFT_CHAT_TAGS_MEASURES,
} from 'cube/constants'

import type { CubeQuery } from '@driftt/dds.reports'

/**
 * Base cube query for the conversation count drill down view.
 */
export const ConversationExportBaseQuery: CubeQuery = {
  name: 'ConversationDataExport',
  queryName: 'ConversationDataExport',
  query: {
    measures: [DRIFT_CHAT_TAGS_MEASURES.NAME_ROLLUP],
    dimensions: [
      CONVERSATION_FACTS_DIMENSIONS.CONVERSATION_ID,
      CONVERSATION_FACTS_DIMENSIONS.CONVERSATION_APP_URL,
      CONVERSATION_FACTS_DIMENSIONS.CONVERSATION_STATUS,
      CONVERSATION_FACTS_ZONE_DIMENSIONS.CONVERSATION_CREATED_AT,
      CONVERSATION_FACTS_ZONE_DIMENSIONS.CONVERSATION_CLOSE_AT,
      DRIFT_APP_USER_FIRST_IN_CONVERSATION.USER_ID,
      DRIFT_APP_USER_FIRST_IN_CONVERSATION.DISPLAY_NAME,
      CONVERSATION_FACTS_DIMENSIONS.END_USER_ID,
      DRIFT_CHAT_END_USERS_DIMENSIONS.DISPLAY_NAME,
      DRIFT_CHAT_END_USERS_DIMENSIONS.EMAIL,
      DRIFT_CHAT_END_USERS_DIMENSIONS.GEO_CITY,
      DRIFT_CHAT_END_USERS_DIMENSIONS.GEO_REGION,
      DRIFT_CHAT_END_USERS_DIMENSIONS.COUNTRY_CODE,
      DRIFT_CHAT_CONVERSATION_ROUTING_DIMENSIONS.TIME_TO_FIRST_RESPONSE_FORMATTED,
      CONVERSATION_FACTS_ZONE_DIMENSIONS.FIRST_USER_INTERACTION_AT,
      CONVERSATION_FACTS_DIMENSIONS.PLAYBOOK_ID,
      DRIFT_CHAT_PLAYBOOK_DIMENSIONS.PLAYBOOK_NAME,
      DRIFT_CHAT_END_USERS_DIMENSIONS.CQL_SCORE,
      DRIFT_CHAT_CLASSIFICATIONS_DIMENSIONS.CLASSIFICATION_NAME,
      CONVERSATION_FACTS_DIMENSIONS.CONVERSATION_CREATED_FROM_URL,
      CONVERSATION_FACTS_DIMENSIONS.CHAT_INTERACTION_COUNT,
      CONVERSATION_FACTS_DIMENSIONS.PARTICIPANT_STATUS,
      DRIFT_CHAT_CONVERSATION_ROUTING_DIMENSIONS.ROUTING_OUTCOME,
    ],
    order: [[CONVERSATION_FACTS_DIMENSIONS.CONVERSATION_ID, 'desc']],
  },
}
